import { DeliveryType, LOCALIZED } from '@libs/core';

import { getSelectedInventory } from '@app/pdp/utils';
import { useProductDetails } from '@app/pdp/hooks';

import { useGetInventories } from './useGetInventories';

const inventoryIds = [
    DeliveryType.BOPIS,
    DeliveryType.SDD,
    LOCALIZED.webInventory,
];

export const useInventories = () => {
    const { selectedDeliveryMethod } = useProductDetails();
    const { inventories, isLoading } = useGetInventories();
    const { selectedProduct } = useProductDetails();

    const [bopis, sdd, web] = inventoryIds.map(deliveryType =>
        getSelectedInventory({
            inventories,
            productId: selectedProduct.objectID,
            deliveryType,
        })
    );

    const selectedProductInventories = { bopis, sdd, web };
    const selectedDeliveryMethodInventory =
        selectedProductInventories[
            selectedDeliveryMethod as keyof typeof selectedProductInventories
        ] ?? web;

    return {
        isLoading,
        inventories,
        selectedProductInventories,
        selectedDeliveryMethodInventory,
    };
};
